var _defs, _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8b8efadf-2129-4630-b5ea-d584c62b827e",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 578 578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-000f4218-2cb1-491a-b246-dd53e69fe614,.uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9{fill:#fff;}.uuid-ed067cfc-2c75-45d7-b610-4f3a35b4a9e4{fill:none;stroke-width:16.9px;}.uuid-ed067cfc-2c75-45d7-b610-4f3a35b4a9e4,.uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9{stroke:#1d1d1b;stroke-linecap:round;stroke-linejoin:round;}.uuid-b7f30132-7a24-480b-b385-f825e18f3669{fill:#dadcdc;}.uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9{stroke-width:16.9px;}.uuid-b6751741-0183-4f37-9cc3-99e17b24ade8{fill:#3b368b;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-000f4218-2cb1-491a-b246-dd53e69fe614",
    x: 137.2,
    y: 80.3,
    width: 303.6,
    height: 413.9,
    rx: 41.4,
    ry: 41.4,
    transform: "translate(-4.8 5) rotate(-1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-b7f30132-7a24-480b-b385-f825e18f3669",
    d: "M266.7,76.5c-22.5,0-44.9,0-67.4,0-19.2,0-41.3,1.4-53,16.7-7.8,10.2-8.6,24-9,36.8-3.3,106-.7,212.2,7.9,317.9,1.5,18,5.3,39.3,21.8,46.8,9.1,4.1,19.7,2.6,29.7,1.2,15.2-2.1,30.7-3.7,45.9-1.4,9.3,1.4,18.3,4.3,27.6,6.1,36.2,7.2,73.7-2.2,108.4-14.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-ed067cfc-2c75-45d7-b610-4f3a35b4a9e4",
    d: "M443.6,451.1c.4,23.3-18.2,42.5-41.5,42.9l-219.1,3.7c-23.3,.4-42.5-18.2-42.9-41.5l-4.7-275.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ed067cfc-2c75-45d7-b610-4f3a35b4a9e4",
    d: "M134.4,121.4c-.4-23.3,18.2-42.5,41.5-42.9l220.9-3.8c22.3-.4,40.7,17.4,41.1,39.7l4.9,289.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-b6751741-0183-4f37-9cc3-99e17b24ade8",
    points: "246.9 177.3 224 238.2 248.9 226.9 259.9 251 281.5 193.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-b6751741-0183-4f37-9cc3-99e17b24ade8",
    points: "310.9 172.8 337.2 236.3 311.9 225.8 301.8 250.3 279.8 197.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-b6751741-0183-4f37-9cc3-99e17b24ade8",
    cx: 279,
    cy: 148.9,
    r: 49.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9",
    x1: 337.9,
    y1: 305.4,
    x2: 407.4,
    y2: 304.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9",
    x1: 184.6,
    y1: 308,
    x2: 293.3,
    y2: 306.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9",
    x1: 273.8,
    y1: 356.5,
    x2: 408.3,
    y2: 354.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9",
    x1: 185.5,
    y1: 358,
    x2: 226.9,
    y2: 357.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9",
    x1: 305.2,
    y1: 406,
    x2: 409.1,
    y2: 404.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-10c2d4a6-7744-4f12-8e5d-4cd113b724a9",
    x1: 186.3,
    y1: 408.1,
    x2: 267.4,
    y2: 406.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.8032bc5198aff92eff52d74e4d9e6fb4.svg";
export { ForwardRef as ReactComponent };